<!-- this page currently holds all components conditionally rendered by step node passed from stepController  -->

<template>
  <div class="step-layout">
    <div class="step-content">
      <component
        v-if="currentNode && !isLoading"
        :is="currentNode.component"
        v-bind="componentProps"
        @input="onValueChange"
      />
      <div v-else-if="isLoading" class="loading">
        <b-spinner style="border-width: 2px" />
      </div>
    </div>

    <div class="step-nav" v-if="currentNode && !isLoading">
      <TongxinNavigation
        :canProceed="canProceed"
        :backButtonIsVisible="currentNode.backButtonIsVisible"
        :textForNextStep="textForNextStep"
        @back="handleBack"
        @next="handleNext"
      />
    </div>
  </div>
</template>

<script>
import TongxinNavigation from '@/components/web/proj/tongxin-demo/layout/TongxinNavigation.vue'
import SelectionStep from '@/components/web/proj/tongxin-demo/SelectionStep.vue'
import Info from '@/components/web/proj/tongxin-demo/Info.vue'
import AddOn from '@/components/web/proj/tongxin-demo/AddOn.vue'
import Notice from '@/components/web/proj/tongxin-demo/Notice.vue'
import TongxinDateSelector from '@/components/web/proj/tongxin-demo/TongxinDateSelector.vue'
import AppointmentTimeSelector from '@/components/web/proj/tongxin-demo/AppointmentTimeSelector.vue';
import stepController from '@/mixins/web/tongxin-demo/stepController'
import Confirmation from '@/components/web/proj/tongxin-demo/Confirmation.vue'
import Success from '@/components/web/proj/tongxin-demo/Success.vue'

export default {
  name: 'DynamicStepContainer',
  components: {
    TongxinNavigation,
    SelectionStep,
    Info,
    AddOn,
    Notice,
    TongxinDateSelector,
    AppointmentTimeSelector,
    Confirmation,
    Success,
  },
  mixins: [stepController],
  props: {
    stepId: {
      type: String,
      required: true
    }
  },
}
</script>

<style scoped>
.step-layout {
  display: flex;
  flex-direction: column;
}

.step-content {
  width: 100%;
  padding: 24px 16px 0; /* single source of spacing above content */
}

.step-nav {
  position: sticky;
  bottom: 0;
  width: 100%;
  padding: 32px 16px 16px;
  background: white;
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 50%,
    rgba(255, 255, 255, 0.2) 100%
  );
  border-top: none;
  box-shadow: none;
}
</style>
